export enum CartSource {
    BuyNow = 'BUY_NOW',
    INVOICE = 'B2B_INVOICE',
}
